<template lang='pug'>
.popupOption.show--smallScreens(@click="$emit('closePopup')")
  ul.popupOption-list
    li.popupOption-item(@click="clickOption('edit')") 編輯
    li.popupOption-item(@click="clickOption('delete')") 刪除
</template>
<script>
export default {
  methods: {
    clickOption(type) {
      this.$emit('closePopup')
      this.$emit('clickOption', type)
    }
  }
}
</script>
